export const INIT_AUTH = 'LOGIN/INIT_AUTH';
export const SET_AUTH = 'LOGIN/SET_AUTH'; 